import $ from 'jquery';
import { Functions } from '../helpers';

export class Map {

	constructor( App ) {
		Map.App       = App;
		Map.UI        = App.PwnUI;
		Map.settings  = App.settings;
    this.$element = $( '.js-pwn-google-map' );
		this.initialize();
	};

	initialize() {
        if ( ! this.$element.length ) return;

        var _lat, _lng, _zoom, _map_type, _marker;

        _lat = this.$element.data( 'lat' );
        _lng = this.$element.data( 'lng' );
        _zoom = this.$element.data( 'zoom' );
        _map_type = this.$element.data( 'map-type' );
        _marker = this.$element.data( 'marker' );

        var _map = new GMaps( {
            div: ".spauto-map",
            lat: _lat,
            lng: _lng,
            zoom: _zoom,
            zoomControl: false,
            scrollwheel: false,
            navigationControl: false,
            mapTypeControl: false,
            scaleControl: false,
            draggable: true,
            disableDoubleClickZoom: false,
            disableDefaultUI: false,
            maptype: _map_type
        } );

        if ( _marker ) {
            _map.addMarker( {
                lat: _lat,
                lng: _lng
            } );
        }

        _map.drawOverlay( {
            lat: _lat,
            lng: _lng,
            content: '<div class="map-hero-pin"><div class="map-hero-pin-shape"><img src="' + Map.settings.theme_uri + '/dist/images/ui/map-pin.png"></div></div>'
        } );
	};
}
